var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.512 8.906c-.236-.282-.656-.32-.939-.085l-2.906 2.422v-7.91c0-.368-.299-.667-.667-.667-.368 0-.667.3-.667.667v7.91L4.427 8.821c-.284-.236-.704-.197-.939.085-.236.283-.198.704.085.94l4 3.332c.032.027.07.04.104.06.027.016.051.035.081.046.078.031.16.05.242.05.083 0 .164-.019.242-.05.03-.011.054-.03.081-.046.035-.02.072-.033.104-.06l4-3.333c.283-.235.321-.656.085-.939",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-down.6923d6ac.svg";
export { ForwardRef as ReactComponent };